<template>
  <cus-order-dialog>
    <template v-slot:body>
      <div class="table">
        <div class="list-wrap">
          <div v-for="item in tempDeviceList" :key="item.device_type_field_name" class="device-item">
            <span class="name">{{ item.device_type_description }}</span>
            <div class="radio-box">
              <cus-radio :radioList="radioList" v-model:selectValue="item.device_enable"></cus-radio>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="關閉" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="儲存" color="blue" :width="50" @click="handleSave"></cus-button>
      </div>
    </template>
  </cus-order-dialog>
</template>

<script>
import { inject, ref, getCurrentInstance } from 'vue';
import { useActions } from '@/utils/mapStore';

export default {
  name: 'deviceSetting',
  setup() {
    const { proxy } = getCurrentInstance();

    // 宣告變數
    const close = inject('order_close');
    const deviceList = ref([]);
    let tempDeviceList = ref([]);
    const radioList = ref([
      {
        label: '啟用',
        value: true,
      },
      {
        label: '不啟用',
        value: false,
      },
    ]);

    // 取得裝置列表
    const doGetDeviceList = useActions('system', ['doGetDeviceList']);
    const init = (async function () {
      const res = await doGetDeviceList();
      deviceList.value = res;
      tempDeviceList.value = JSON.parse(JSON.stringify(res));
    })();

    // 儲存
    const doDeviceSave = useActions('system', ['doDeviceSave']);
    const save = async function () {
      try {
        await doDeviceSave(tempDeviceList.value);
      } catch {
        tempDeviceList.value = JSON.parse(JSON.stringify(deviceList.value));
      }
    };

    const handleSave = () => {
      if (checkDeviceEnable().length) {
        confirmDeviceDisable();
      } else {
        save();
      }
    };

    // 檢查是否有不啟用的設備
    const checkDeviceEnable = () => {
      const disabledList = tempDeviceList.value
        .filter((item) => {
          return item.device_enable === false;
        })
        .map((item) => {
          return item.device_type_description;
        });
      return disabledList;
    };

    // 確認關閉設備彈窗
    const confirmDeviceDisable = async () => {
      const deviceName = checkDeviceEnable().toString().replace(/,/g, '、');
      proxy
        .$confirm({
          content: `${deviceName} 設備將無法使用，是否確定關閉？`,
          confirmText: '關閉',
          confirm2Text: '取消',
          moreConfirm: true,
        })
        .then((val) => {
          if (val === '關閉') {
            save();
          } else if (val === '取消') {
            tempDeviceList.value = JSON.parse(JSON.stringify(deviceList.value));
          }
        })
        .catch((e) => e);
    };

    return {
      close,
      init,
      deviceList,
      tempDeviceList,
      radioList,
      handleSave,
    };
  },
};
</script>

<style lang="scss" scoped>
.table {
  border: 2px solid $color-gray-10;
  border-radius: 4px;
}
.list-wrap {
  height: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: repeat(10, 10%);
  grid-auto-flow: column;
}
.device-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
  outline: 1px solid #e6e6e6;
  .name {
    font-size: 2.2rem;
    color: #29313e;
  }
}
.radio-box {
  width: 190px;
}
</style>
